import { memo, useEffect } from "react";
import { Form, InputGroup, OverlayTrigger } from "react-bootstrap";
import { Controller, useFormContext } from "react-hook-form";
import { NumericFormat } from "react-number-format";
import { toast } from "react-toastify";

const PASTE_ERROR =
  "You can paste only positive numbers with no more than two digits after decimal separator.";

/**
 * Component has been deprecated and should not be used anymore.
 * @deprecated Use components from shared/ui instead
 */
const FormNumericInput = function FormNumericInput({
  name,
  label = "",
  addon = "",
  text = "",
  displayAs = Form.Group,
  className = "",
  resetField = undefined,
  ...props
}) {
  const {
    formState: { errors },
    setValue,
  } = useFormContext();

  useEffect(() => {
    return () => resetField && resetField(name);
    //eslint-disable-next-line
  }, []);

  const handleOnPaste = (e) => {
    let value = e.clipboardData.getData("Text");

    const isNotCompatibleNumber = !value.match(/^([\d ]+(?:[.,]\d{1,2})?)$/);
    const isStartingWithZeros = value.match(/^0[0-9].*$/);

    if (isNotCompatibleNumber || isStartingWithZeros) {
      e.preventDefault();
      toast(PASTE_ERROR, {
        type: "error",
        toastId: "on-paste-error",
        theme: "colored",
      });
    } else if (value.indexOf(",") !== -1) {
      e.preventDefault();
      setValue(name, value.replace(",", "."));
    }
  };

  return (
    <Form.Group as={displayAs} className={className}>
      {label && <Form.Label>{label}</Form.Label>}
      <InputGroup hasValidation>
        {addon && <InputGroup.Text id={addon}>{addon}</InputGroup.Text>}
        <Controller
          name={name}
          render={({ field: { onChange, name, value } }) => (
            <NumericFormat
              customInput={Form.Control}
              name={name}
              label={label}
              thousandSeparator={" "}
              allowNegative={false}
              allowedDecimalSeparators={[",", "."]}
              decimalSeparator={"."}
              decimalScale={2}
              valueIsNumericString={true}
              onChange={onChange}
              onValueChange={(val) => setValue(name, val.formattedValue)}
              value={value}
              isAllowed={({ floatValue }) =>
                floatValue === undefined ||
                (floatValue <= 999999999999.99 && floatValue > 0)
              }
              onPaste={handleOnPaste}
              isInvalid={!!errors[name]}
              {...props}
            />
          )}
        />
        <Form.Control.Feedback type="invalid">
          {errors[name]?.message.toString()}
        </Form.Control.Feedback>
      </InputGroup>
      {!errors[name] && text && <Form.Text>{text}</Form.Text>}
    </Form.Group>
  );
};

const WithPopover = function WithPopover({
  name,
  label = "",
  addon = "",
  text = "",
  popover,
  popoverPlacement = "top",
  displayAs = Form.Group,
  className = "",
  resetField = undefined,
  ...props
}) {
  const {
    formState: { errors },
    setValue,
  } = useFormContext();

  useEffect(() => {
    return () => resetField && resetField(name);
    //eslint-disable-next-line
  }, []);

  const handleOnPaste = (e) => {
    let value = e.clipboardData.getData("Text");

    const isNotCompatibleNumber = !value.match(/^([\d ]+(?:[.,]\d{1,2})?)$/);
    const isStartingWithZeros = value.match(/^0[0-9].*$/);

    if (isNotCompatibleNumber || isStartingWithZeros) {
      e.preventDefault();
      toast(PASTE_ERROR, {
        type: "error",
        toastId: "on-paste-error",
        theme: "colored",
      });
    } else if (value.indexOf(",") !== -1) {
      e.preventDefault();
      setValue(name, value.replace(",", "."));
    }
  };

  return (
    <Form.Group as={displayAs} className={className}>
      <Form.Label>{label}</Form.Label>
      <OverlayTrigger
        overlay={popover}
        // @ts-ignore
        placement={popoverPlacement}
      >
        <InputGroup hasValidation>
          {addon && <InputGroup.Text id={addon}>{addon}</InputGroup.Text>}
          <Controller
            name={name}
            render={({ field: { onChange, name, value } }) => (
              <NumericFormat
                customInput={Form.Control}
                name={name}
                label={label}
                thousandSeparator={" "}
                allowNegative={false}
                allowedDecimalSeparators={[",", "."]}
                decimalSeparator={"."}
                decimalScale={2}
                valueIsNumericString={true}
                onChange={onChange}
                onValueChange={(val) => setValue(name, val.formattedValue)}
                value={value}
                isAllowed={({ floatValue }) =>
                  floatValue === undefined ||
                  (floatValue <= 999999999999.99 && floatValue > 0)
                }
                onPaste={handleOnPaste}
                isInvalid={!!errors[name]}
                {...props}
              />
            )}
          />
          <Form.Control.Feedback type="invalid">
            {errors[name]?.message.toString()}
          </Form.Control.Feedback>
        </InputGroup>
      </OverlayTrigger>
      {!errors[name] && text && <Form.Text>{text}</Form.Text>}
    </Form.Group>
  );
};

FormNumericInput.WithPopover = memo(WithPopover);
export default FormNumericInput;
